import axios from "axios";

import { Wallet } from "../../types/wallet/wallet";

export interface UpdateWalletBody {
  apiKey?: string;
  secretKey?: string;
  passphrase?: string;
  customName?: string;
}

export const updateWallet = async (
  walletId: string,
  newProps: UpdateWalletBody
): Promise<Wallet> => {
  const { data } = await axios.patch(`/wallets/${walletId}`, newProps);
  return data;
};
